/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useCallback } from "react";
import { Row, Col } from "react-flexbox-grid";

import { PageWrapper } from "components";
import { InputLine, DatePicker, Button, Avatar } from "components/core";
import { useGlobalContext } from "context/GlobalContext";
import { withLoader } from "HOC";
import { phoneRegExp, urlRegExp } from "constants/index";
import Typography from "@material-ui/core/Typography";
import { fetchBackend, formatSchemaUser, uploadFileBase64 } from "helpers";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const SchemaSignIn = yup.object().shape({
  name: yup.string().required("Ingrese su nombre para continuar"),
  phoneNumber: yup
    .string()
    .length(10, "El número de teléfono debe tener 10 caracteres")
    .matches(phoneRegExp, "El número de teléfono no es válido"),
});

const Account = ({ setLoading }) => {
  // eslint-disable-next-line no-unused-vars
  const [currentClient, setClient] = useState(null);
  const [isChargin, setCharge] = useState(false);

  const gContext = useGlobalContext();

  const { handleSubmit, register, control, errors } = useForm({
    resolver: yupResolver(SchemaSignIn),
  });

  const updateUser = useCallback(
    async (obj) => {
      const id = gContext.currentUser._id;

      const { error } = await fetchBackend({
        method: "put",
        url: `user/${id}`,
        data: obj,
      });

      if (!error) {
        setCharge(false);
        gContext.handleSetUser({ ...obj, _id: id });
        gContext.toggleAlert({
          message: "Información actualizada con exito",
        });
      } else {
        setCharge(false);
        gContext.toggleAlert({
          message:
            "Hubo un error al intentar actualizar tu información, revisa la información",
          type: "error",
        });
      }
    },
    [gContext.currentUser]
  );

  useEffect(() => {
    if (gContext.currentUser) {
      const data = formatSchemaUser(gContext.currentUser);
      setClient(data);
      setLoading(false);
    }
  }, [gContext.currentUser]);

  const uploadPicture = async (id, item) => {
    return new Promise((res, rej) => {
      uploadFileBase64(
        item,
        `users/${id}`,
        (url) => res(url),
        (percetage) => percetage === 100 && console.log("file upload")
      );
    });
  };

  const onSubmit = useCallback(
    async ({
      name,
      lastNames,
      birthDay,
      phoneNumber,
      homeNumber,
      houseNumber,
      streetName,
      colonia,
      state,
      profileUrl,
      CP,
    }) => {
      const id = gContext.currentUser._id;

      const SchemaDirection = {
        streetName,
        colonia,
        state,
        CP,
      };

      const obj = {
        name,
        lastNames,
        birthDay,
        phoneNumber,
        homeNumber,
        houseNumber,
        profileUrl,
        email: currentClient.value || "",
        password: currentClient.value || "",
        direction: SchemaDirection,
        conecktaId: currentClient.conecktaId || "",
        dateCreated: currentClient.dateCreated || Date(),
        uid: currentClient.uid || "",
      };

      setCharge(true);

      if (profileUrl && !urlRegExp.test(profileUrl)) {
        // si es url
        const picture = await uploadPicture(id, profileUrl);
        await updateUser({ ...obj, profileUrl: picture });
      } else {
        await updateUser(obj);
      }
    },
    [gContext.currentUser, currentClient]
  );

  if (!currentClient) return null;

  return (
    <PageWrapper
      header={
        <Row center="xs">
          <Col md={12}>
            <h1>Datos personales</h1>
          </Col>
        </Row>
      }
    >
      <Col md={12} className="mt4">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row center="xs">
            <Controller
              name="profileUrl"
              control={control}
              defaultValue={currentClient?.profileUrl || ""}
              render={(props) => (
                <Avatar
                  onChange={(file) => props.onChange(file)}
                  defaultValue={props.value}
                />
              )} // props contains: onChange, onBlur and value
            />
          </Row>
          <Row className="pa2">
            <Typography variant="button" color="secondary">
              Información personal
            </Typography>
          </Row>
          <Row center="xs">
            <InputLine
              md={6}
              name="name"
              label="Nombre"
              defaultValue={currentClient?.name}
              ref={register}
              error={errors.name?.message}
            />
            <InputLine
              md={6}
              name="lastNames"
              label="Apellidos"
              defaultValue={currentClient?.lastNames}
              ref={register}
              error={errors.lastNames?.message}
            />
            <Controller
              name="birthDay"
              control={control}
              defaultValue={
                currentClient?.birthDay
                  ? new Date(currentClient?.birthDay)
                  : new Date()
              }
              render={(props) => (
                <DatePicker
                  md={6}
                  label="Fecha de nacimiento"
                  value={props.value}
                  onChange={(date) => props.onChange(date)}
                  error={errors.birthDay?.message}
                />
              )} // props contains: onChange, onBlur and value
            />

            <InputLine
              md={6}
              type="number"
              name="phoneNumber"
              label="Celular"
              defaultValue={currentClient?.phoneNumber}
              ref={register}
              error={errors.phoneNumber?.message}
            />
            <InputLine
              md={6}
              type="number"
              name="homeNumber"
              label="Número de casa"
              defaultValue={currentClient?.homeNumber}
              ref={register}
              error={errors.homeNumber?.message}
            />
            <InputLine
              md={6}
              type="number"
              name="houseNumber"
              label="Número de trabajo"
              defaultValue={currentClient?.houseNumber}
              ref={register}
              error={errors.houseNumber?.message}
            />
          </Row>
          <Row className="pa2">
            <Typography variant="button" color="secondary">
              Dirección personal
            </Typography>
          </Row>
          <Row center="xs">
            <InputLine
              md={6}
              name="streetName"
              label="Calle"
              defaultValue={currentClient?.streetName}
              ref={register}
              error={errors.streetName?.message}
            />
            <InputLine
              md={6}
              name="colonia"
              label="Colonia"
              defaultValue={currentClient?.colonia}
              ref={register}
              error={errors.colonia?.message}
            />
            <InputLine
              md={6}
              name="state"
              label="Estado"
              defaultValue={currentClient?.state}
              ref={register}
              error={errors.state?.message}
            />
            <InputLine
              md={6}
              name="CP"
              label="Código postal"
              defaultValue={currentClient?.CP}
              ref={register}
              error={errors.CP?.message}
            />
          </Row>
          <Row center="xs" className="mt4">
            <Button
              color="primary"
              htmlType="submit"
              className="w-100"
              loading={isChargin}
            >
              Guardar
            </Button>
          </Row>
        </form>
      </Col>
    </PageWrapper>
  );
};

export default withLoader(Account, "Cargando datos de cuenta");
